export const SIDEBAR_SIZES = {
  NORMAL: 355,
  TIMELINE: 300,
};
